module.exports = __webpack_public_path__ + "static/media/25.238e47d4.jpg";